if (!window.updateRec){
    window.updateRec = function() {
        // product reco functionality
        function getVisibleRecoItems(container) {
            const totalGuideItems = container.querySelectorAll('.product-rec-item').length;
            const windowWidth = document.body.getBoundingClientRect().width;
            // return number of items based on screen width and total items
            if (windowWidth > 1200) {
                return totalGuideItems >= 3 ? 3 : totalGuideItems;
            } else if (windowWidth < 1200 && windowWidth > 576) {
                return totalGuideItems >= 2 ? 2 : totalGuideItems;
            } else {
                return 1;
            }
        }
    
        function moveRecoSlide(dir, container) {
            let siblingType = 'nextElementSibling';
            if (dir == -1) {
                siblingType = 'previousElementSibling';
                const allActive = container.querySelectorAll('.product-rec-item.active:not(.current)');
                if (allActive.length > 0) {
                    /* if the first sequential element is active, and the last sequential element is active
                     * because we're going backwards, we want to hide the first one not the last one
                    */
                    if (!allActive[0].parentNode.previousElementSibling && !allActive[1].parentNode.nextElementSibling) {
                        allActive[0].classList.remove('active');
                        allActive[0].classList.add('hidden');
                    } else {
                        allActive[allActive.length -1].classList.remove('active');
                        allActive[allActive.length -1].classList.add('hidden');
                    }
                }
            }
            // check how many visible items and apply classes accordingly
            const visibleItems = getVisibleRecoItems(container);
            let activeRecoItem = container.querySelector('.product-rec-item.active.current');
            let nextRecoItem = activeRecoItem.parentNode[siblingType];
            activeRecoItem.classList.remove('active');
            activeRecoItem.classList.remove('current');
            activeRecoItem.classList.add('hidden');
            activeRecoItem.parentNode.style.order = '';
            let secondNextRecoItem;
            let thirdNextRecoItem;
            if (visibleItems >= 1) {
                if (!nextRecoItem) {
                    let selector = 'product-rec'+(dir == -1 ? ':last-of-type' : '');
                    nextRecoItem = container.querySelector(selector + ' .product-rec-item');
                } else {
                    nextRecoItem = nextRecoItem.querySelector('.product-rec-item');
                }
                nextRecoItem.classList.add('active');
                nextRecoItem.classList.add('current');
                nextRecoItem.parentNode.style.order = '2';
                nextRecoItem.classList.remove('hidden');
            }
            if (visibleItems >= 2) {
                secondNextRecoItem = nextRecoItem?.parentNode?.nextElementSibling?.querySelector('.product-rec-item');
                if (!secondNextRecoItem) secondNextRecoItem = container.querySelector('.product-rec-item');
                secondNextRecoItem.classList.add('active');
                secondNextRecoItem.parentNode.style.order = '1';
                secondNextRecoItem.classList.remove('hidden');
            }
            if (visibleItems >= 3) {
                thirdNextRecoItem = secondNextRecoItem?.parentNode?.nextElementSibling?.querySelector('.product-rec-item');
                if (!thirdNextRecoItem) thirdNextRecoItem = container.querySelector('.product-rec-item');
                thirdNextRecoItem.classList.add('active');
                thirdNextRecoItem.classList.remove('hidden');
            }
            showHideRecoArrows(container);
        }
    
        function showHideRecoArrows(container) {
            const visibleItems = getVisibleRecoItems(container);
            const totalRecoItems = container.querySelectorAll('.product-rec-item').length;
            let display = 'block';
            const prevButton = container.querySelector('.reco-prev');
            const nextButton = container.querySelector('.reco-next');
    
            if (visibleItems >= totalRecoItems) {
                display = 'none';
            }
            if (prevButton) {
                prevButton.style.display = display;
            }
            if (nextButton) {
                nextButton.style.display = display;
            }
        }
    
        function updateAllRecoModules() {
            const recoContainers = document.querySelectorAll('.product-rec-container');
            // loop through all reco containers
            recoContainers.forEach((container, index) => {
                // total number of items
                const totalRecoItems = container.querySelectorAll('.product-rec-item').length;
                // get the max number of visible items
                let visibleItems = getVisibleRecoItems(container);
                // get all active items
                let activeRecoItems = container.querySelectorAll('.product-rec-item.active');
                if (activeRecoItems.length > visibleItems) {
                    // if there are more active items than visible, hide the rest (starting from the last)
                    activeRecoItems.forEach((item, index) => {
                        if (index >= visibleItems) {
                            item.classList.remove('active');
                            item.classList.add('hidden');
                        }
                    });
                } else if (activeRecoItems.length < visibleItems && totalRecoItems >= visibleItems) {
                    // if there are less active items than visible, show the rest (up to the visible limit)
                    while (container.querySelectorAll('.product-rec-item.active').length < visibleItems) {
                        activeRecoItems = container.querySelectorAll('.product-rec-item.active');
                        if (activeRecoItems.length == 0) {
                            container.querySelector('.product-rec-item').classList.add('active');
                            container.querySelector('.product-rec-item').classList.add('current');
                            container.querySelector('.product-rec-item').classList.remove('hidden');
                            activeRecoItems = container.querySelectorAll('.product-rec-item.active');
                        }
                        let nextRecoItem = activeRecoItems[activeRecoItems.length - 1].nextElementSibling;
                        if (!nextRecoItem && activeRecoItems.length < visibleItems) {
                            nextRecoItem = container.querySelector('.product-rec-item:not(.active)');
                        }
                        nextRecoItem?.classList.add('active');
                        nextRecoItem?.classList.remove('hidden');
                    }
                }
                showHideRecoArrows(container);
            });
        }
    
        // get all reco containers
        const recoContainers = document.querySelectorAll('.product-rec-container');
        // loop through all reco containers
        recoContainers.forEach((container, index) => {
            const recoItems = container.querySelectorAll('.product-rec-item');
            recoItems.forEach((item, index) => {
                item.classList.add('hidden');
                item.classList.remove('active');
            });
            container.querySelector('.reco-prev')?.addEventListener('click', (e) => moveRecoSlide(-1, e.target.closest('.product-rec-container')));
            container.querySelector('.reco-next')?.addEventListener('click', (e) => moveRecoSlide(1, e.target.closest('.product-rec-container')));
        });
        window.addEventListener('resize', updateAllRecoModules);
        updateAllRecoModules();
    };
    document.addEventListener('DOMContentLoaded', window.updateRec);
}
